import { render, staticRenderFns } from "./DeclarationsList.vue?vue&type=template&id=06140f4c&"
import script from "./DeclarationsList.vue?vue&type=script&lang=ts&"
export * from "./DeclarationsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports